export default function Categorical_Data() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Categorical_Data</h1>
      <p>Content for Categorical_Data goes here.</p>
    </div>
  );
}